import { Injectable } from '@angular/core';
import 'rxjs/add/operator/timeoutWith';
import 'rxjs/add/observable/throw';

import { AppGlobal} from './app.global'

import { environment } from '../environments/environment';

@Injectable()
export class GoogleService {

  constructor(private appGlobal: AppGlobal) {}

  sendException(description) {
    if (environment.googlecode.startsWith('G-')) { 
      (<any>window).gtag('event', 'exception', {
        description: description,
        fatal: false
      });
    }
    this.sendOldEvent(description, '/formulaire/garantie');
  }

  sendEvent(eventAction, eventCategory)  {
    if (environment.googlecode.startsWith('G-')) {  
      (<any>window).gtag('event', eventAction, {
        content_type: eventAction,
        item_id: eventCategory
      });
    } 
    this.sendOldEvent(eventAction, eventCategory);
  }

  private sendOldEvent(eventAction, eventCategory)  {
    if (environment.googlecode.startsWith('UA')) {
      (<any>window).ga('send', 'event', {
        eventCategory: eventCategory,
        eventLabel: '',
        eventAction: eventAction,
        eventValue: 0
      });
    }
  }

  pageView(link) {
    if (environment.googlecode.startsWith('G-')) {  
      (<any>window).gtag('event', 'screen_'+link, {
        screen_name: link
      });
    } 
    if (environment.googlecode.startsWith('UA')) {
      (<any>window).ga('set', 'page', link);
      (<any>window).ga('send', 'pageview');
    }
  }

  selectProduct(idDevis, productCode, discount, price) {
    if (environment.googlecode.startsWith('G-')) {  
      (<any>window).gtag('event', 'add_to_cart', {
        currency: 'EUR',
        items: [{
          item_id: idDevis,
          item_name: productCode,
          discount: discount,
          price: price,
          currency: 'EUR',
          quantity: 1
        }],
        value: price
      });
    }
    this.sendOldEvent('POPIN_SOUSCRIRE', '/formulaire/garantie');
  }

  viewListProduct(products) {
    if (environment.googlecode.startsWith('G-')) {  
      let count = 0;
      let items = products.map(product => {
        count = count + 1;
        return {
          id: product.idDevis,
          name: this.appGlobal.getProductTitle(product.serviceKey),
          brand: product.serviceKey,
          list_name: "products result " + this.appGlobal.getProductTitle(product.serviceKey),
          list_position: count,
          price: product.primeTotale
        }});
      (<any>window).gtag('event', 'view_item_list', {
        items: items
      });
    }
    this.sendOldEvent('RECIEVE PRODUCTS RESULTS ' + products.length, '/formulaire/garantie');
  }

  addWishlistProduct(idDevis, productCode, discount, price) {
    if (environment.googlecode.startsWith('G-')) {  
      (<any>window).gtag('event', 'add_to_wishlist', {
        currency: 'EUR',
        items: [{
          item_id: idDevis,
          item_name: productCode,
          discount: discount,
          price: price,
          currency: 'EUR',
          quantity: 1
        }],
        value: 10
      });
    } 
    this.sendOldEvent('POPIN_SAUVEGARDE', '/formulaire/garantie');
  }
}



// WEBPACK FOOTER //
// ./src/app/google.service.ts